export default __webpack_public_path__ + "static/media/landing1.6c22db8b.jpg";